import { createContext, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { empresasService } from "app/services";

const ExportacionContext = createContext();

const initialState = {
  exportacion_detalles: "",
  exportacion_principal: false,
};

export function ExportacionProvider({ children }) {
  const params = useParams();

  const [exportacion, setExportacion] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const exportacionQuery = useQuery({
    queryKey: [
      "empresa:get:exportacion",
      params.empresa_id,
      params.exportacion_id,
    ],
    queryFn: () =>
      empresasService.getExportacion({
        empresaId: params.empresa_id,
        exportacionId: params.exportacion_id,
      }),
    onSuccess: (data) => {
      setExportacion(data);
      setEditing(true);
    },
    enabled: !!params.exportacion_id,
  });

  if (!!exportacionQuery.isLoading && !!params.exportacion_id) {
    return <Spinner label="Cargando la exportación..." />;
  } else if (!!exportacionQuery.isFetching && !!params.exportacion_id) {
    return <Spinner label="Recuperando la exportación..." />;
  } else if (!!exportacionQuery.isRefetching && !!params.exportacion_id) {
    return <Spinner label="Recargando la exportación..." />;
  } else if (!!exportacionQuery.isError) {
    return (
      <ErrorMessage message={exportacionQuery.error.response.statusText} />
    );
  }

  return (
    <ExportacionContext.Provider
      value={{
        exportacion,
        setExportacion,
        isEditing,
      }}
    >
      {children}
    </ExportacionContext.Provider>
  );
}

export function useExportacionContext() {
  const exportacionContext = useContext(ExportacionContext);

  if (!exportacionContext) {
    throw new Error(
      "useExportacionContext should be used inside the ExportacionProvider."
    );
  }

  return exportacionContext;
}
